import { resources } from "@constants/hardcoded-strings";
import { FormattedPolicyComponent, PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { addObjectsToArrayInCommonReferenceData } from "@redux/actions/common-reference-data-actions";
import { addPolicyComponent } from "@redux/actions/policy-components-actions";
import { createPolicyComponentRequest } from "@requests/service-configuration";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getPolicyComponent } from "@utils/policies/policy-component-util";
import cloneDeep from "lodash/cloneDeep";
import { Dispatch } from "redux";

export const createPolicyComponentReduxRequest = (dispatch: Dispatch) => async (
    formattedPolicyComponent: FormattedPolicyComponent,
    updateCommonReferenceData: boolean
): Promise<PolicyComponent> => {
    const policyComponent = getPolicyComponent(cloneDeep(formattedPolicyComponent));
    const { data, error, body } = await createPolicyComponentRequest(policyComponent);
    if (data?.response) {
        displaySuccessModal(
            dispatch,
            resources.requests.createPolicyComponent.success.title,
            resources.requests.createPolicyComponent.success.message
        );

        const { conditions, ...deployedPolicyComponent } = data.response;

        if (updateCommonReferenceData) {
            dispatch(addObjectsToArrayInCommonReferenceData([deployedPolicyComponent], "deployedPolicyComponents"))
        } else {
            dispatch(addPolicyComponent({
                ...deployedPolicyComponent,
                permissions: {
                    canView: true,
                    canModify: true
                }
            }));
        }
        dispatch(addObjectsToArrayInCommonReferenceData(conditions, "simpleDeployedPolicyComponentConditions"));
        return data.response;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.createPolicyComponent.error.title,
                resources.requests.createPolicyComponent.error.message,
                error,
                null,
                body
            );
        }
    }

    return null;

};